import { render, staticRenderFns } from "./WOStatistics.vue?vue&type=template&id=13176a6b&"
import script from "./WOStatistics.vue?vue&type=script&lang=js&"
export * from "./WOStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports